<!--
 * @Author: liliujun
 * @Date: 2025-11-11
 * @LastEditors: liliujun
 * @LastEditTime: 2025-11-13
 * @FilePath: /mall/yunNanMall/src/views/company/components/column-goods.vue
 * @Description:
-->
<template>
  <div class="goods-wrapper" id="goodsWrapper">
    <sticky :offset-top="0">
      <div class="tab-wrapper">
        <tabs v-model="current" background="transparent" :border="false">
          <tab v-for="(tab, index) in tabs" :title="tab.title" :key="index" />
        </tabs>
      </div>
    </sticky>
    <div class="tab-content">
      <van-list
        v-show="goodsList.length"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="reachBototm"
      >
        <goods-list :sku-list="goodsList" />
      </van-list>
      <div class="no-data" v-if="noData">
        暂时数据
      </div>
    </div>
  </div>
</template>

<script>
import GoodsList from '@/components/ProductDoubleEach'
import { Tabs, Tab, Sticky } from 'vant'
let flag = false
export default {
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Tabs,
    Tab,
    Sticky,
    GoodsList
  },
  data () {
    return {
      current: 0,
      loading: false,
      finished: false,
      goodsList: [],
      pageNum: 1,
      noData: false
    }
  },
  computed: {
    tabs () {
      const colunms = JSON.parse(JSON.stringify(this.columns))
      colunms.unshift({ title: '全部', cid: 0 })
      return colunms
    },
    currentTab () {
      return this.tabs[this.current] || {}
    }
  },
  watch: {
    current () {
      this.$toast.loading('加载中...')
      this.initData()
    }
  },
  created () {
    this.$toast.loading('加载中...')
    this.getGoodsList()
  },
  methods: {
    async initData () {
      const data = {
        loading: false,
        finished: false,
        goodsList: [],
        pageNum: 1,
        noData: false
      }
      Object.assign(this.$data, data)
      window.scrollTo(0, document.getElementById('goodsWrapper').offsetTop)
      await this.getGoodsList()
    },
    async  getGoodsList (page) {
      const res = await (this.current === 0
        ? this.$axios.get(`api/goods/goodsAllCid/${page || 1}/10`)
        : this.$axios.get(`/api/goods/channelItemsFirst/${this.currentTab.column}/${page || 1}`))
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data } = res.data
        if (code === 0) {
          this.goodsList = [...this.goodsList, ...data]
        } else if (code === 9006) {
          if (!page) {
            this.noData = true
          }
          this.finished = true
        }
      }
    },
    reachBototm () {
      if (this.finished) {
        return false
      }
      if (flag) {
        return false
      }
      flag = true
      this.getGoodsList(++this.pageNum).then((res) => {
        setTimeout(() => {
          this.loading = false
          flag = false
        }, 500)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tab-content,
.tab-wrapper {
  padding: 0 0.2rem;
  background-color: #f6f6f6;
}
.tab-wrapper {
  /deep/ .van-tabs__line {
    bottom: 0.4rem;
    width: 6% !important;
    background: linear-gradient(270deg, #f0e1ce 26%, #dcbfa0 95%);
  }
  /deep/ .van-tab,
  /deep/ .van-tab--active {
    max-width: 1.6rem;
    margin-right: 0.2rem;
    color: #373737;
    flex: 1 0 auto !important;
  }
  /deep/ .van-tab {
    font-size: 0.26rem;
  }
  /deep/ .van-tab--active {
    font-size: 0.32rem;
  }
}
.tab-content {
  min-height: calc(100vh - 94px);
}
.no-data {
  text-align: center;
  padding-top: 40%;
  color: #999;
  font-size: 0.32rem;
}
</style>
